import "bootstrap-touchspin"

export function attachNumber($context) {
    $context.find(".touchspin").TouchSpin({
        max: 1000000000,
    })
}
